import { connect } from 'react-redux';
import { noop } from 'lodash-es';
import { type ComponentType } from 'react';
import { loadSuccess } from './store';
import { type AsyncItem, type AsyncItemContext } from './types';

type ReduxState = {
  reduxAsyncConnect?: Record<string, unknown>;
} & Record<string, unknown>;

type AsyncComponent = ComponentType<any> & {
  reduxAsyncConnect?: AsyncItem;
};

const wrapWithDispatch = (asyncItem: AsyncItem) => {
  return {
    ...asyncItem,
    promise: (context: AsyncItemContext) =>
      asyncItem
        .promise(context)
        .then((data) =>
          context.store.dispatch(loadSuccess(asyncItem.key, data)),
        )
        .catch(noop),
  };
};

export const asyncConnect =
  (asyncItem: AsyncItem, mapStateToProps: any, mapDispatchToProps: any) =>
  (Component: AsyncComponent) => {
    Component.reduxAsyncConnect = wrapWithDispatch(asyncItem);

    const finalMapStateToProps = (state: ReduxState, ownProps: any) => ({
      ...mapStateToProps(state, ownProps),
      [asyncItem.key]: state?.reduxAsyncConnect?.[asyncItem.key],
    });

    return connect(finalMapStateToProps, mapDispatchToProps)(Component);
  };
